import { render, staticRenderFns } from "./resume-citizenships.vue?vue&type=template&id=a5f68a20&"
import script from "./resume-citizenships.vue?vue&type=script&lang=js&"
export * from "./resume-citizenships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports